import styled, { css } from 'styled-components';
import {
  maxWidthPositionFixed,
  visibilityAnimationRight,
} from '../../ModalMonitoringStyles';

export const Container = styled.footer`
  ${({ theme }) => css`
    position: fixed;
    width: 100%;
    bottom: 0;
    right: -100%;
    opacity: 0;
    max-width: ${maxWidthPositionFixed};
    padding: ${theme.spacing.km6} ${theme.spacing.km8};
    background-color: ${theme.color.background.neutral.default};
    box-shadow: 0px 12px 42px -4px rgba(38, 47, 74, 0.12),
      0px 8px 18px -6px rgba(38, 47, 74, 0.12);

    ${visibilityAnimationRight}
  `}
`;
